'use client'

import { useState } from 'react'
import { Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { FAQ_ITEMS } from './faq-items'

export function Faq() {
  const t = useTranslations('landing')
  const [open, setOpen] = useState<string | null>('launch')

  return (
    <section className="bg-white py-24" id="faq">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.08em] text-primary">
            {t('faq.eyebrow')}
          </p>
          <h2 className="font-serif text-4xl font-bold tracking-tight md:text-5xl">
            {t('faq.title')} <span className="italic text-primary">{t('faq.titleAccent')}</span>
          </h2>
        </div>

        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          {FAQ_ITEMS.map((key) => {
            const isOpen = open === key
            return (
              <div
                key={key}
                className="overflow-hidden rounded-2xl border border-slate-200 bg-white"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? null : key)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-semibold"
                >
                  {t(`faq.items.${key}.q` as Parameters<typeof t>[0])}
                  <Plus
                    className={cn(
                      'h-5 w-5 flex-shrink-0 text-primary transition-transform duration-200',
                      isOpen && 'rotate-45'
                    )}
                  />
                </button>
                <div
                  className={cn(
                    'grid transition-all duration-300',
                    isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  )}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 leading-relaxed text-muted-foreground">
                      {t(`faq.items.${key}.a` as Parameters<typeof t>[0])}
                    </p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
